import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-winners',
  templateUrl: './winners.component.html',
  styleUrls: ['./winners.component.scss']
})
export class WinnersComponent implements OnInit {
  isCollapsed = new Array(5).fill(true);

  constructor() { }

  ngOnInit() {
  }
}
